// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2aNA8","title":"styles_title__3JWY-"};